(() => {
  const portal = 'https://portal.avidrace.com';
  document.querySelectorAll('[data-library-product-documents]').forEach(async root => {
    if (root.dataset.loaded) return;
    root.dataset.loaded = 'true';
    try {
      const response = await fetch(`${portal}/api/public/documents?product=${encodeURIComponent(root.dataset.productId)}`, { credentials: 'omit' });
      if (!response.ok) throw new Error('Documents unavailable');
      const data = await response.json();
      if (!Array.isArray(data.documents) || !data.documents.length) return;
      const list = document.createElement('ul');
      list.className = 'product-downloads';
      data.documents.forEach(doc => {
        if (!/^[a-z0-9-]+$/.test(doc.slug || '')) return;
        const item = document.createElement('li');
        const link = document.createElement('a');
        const url = `${portal}/api/public/documents/${doc.slug}/download?inline=1`;
        // The Portal reader renders every page of this same published PDF.
        // Native PDF iframes on iOS can expose only the first page.
        link.href = `${portal}/documents/${doc.slug}`; link.target = '_blank'; link.rel = 'noopener';
        const copy = document.createElement('span'); copy.className = 'product-downloads__copy';
        const title = document.createElement('strong'); title.textContent = doc.title;
        const revision = document.createElement('small'); revision.textContent = doc.revisionLabel;
        copy.append(title, revision); link.append(copy); item.append(link); list.append(item);
        // Reuse the installed PDFConnect modal. The link remains a native fallback.
        link.addEventListener('click', event => {
          if (window.matchMedia('(max-width: 989px), (pointer: coarse)').matches || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (typeof window.openPdfModal === 'function') {
            event.preventDefault(); window.openPdfModal(url, doc.title, '', true);
            const modal = document.getElementById('pdfModal');
            if (modal) {
              modal.classList.add('avid-library-pdf');
              modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', doc.title);
              modal.querySelector('iframe')?.setAttribute('title', doc.title);
              modal.querySelector('[data-pdfc-close].pdf-modal-close')?.focus();
            }
          }
        });
      });
      if (list.children.length) { root.append(list); root.hidden = false; }
    } catch (_) {
      // Preserve existing downloads and show a retry only inside the downloads area.
      root.hidden = false;
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button button--secondary';
      retry.textContent = 'Guide links unavailable. Reload to retry';
      retry.addEventListener('click', () => window.location.reload()); root.append(retry);
    }
  });
})();
